import { ApiService } from 'src/app/services/api.service';

import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NavController } from '@ionic/angular';

import { DataService } from '../../services/data.service';

@Component({
  selector: 'app-category',
  templateUrl: './category.page.html',
  styleUrls: ['./category.page.scss'],
})
export class CategoryPage implements OnInit {
  category;

  categories;
  constructor(
    private route: ActivatedRoute,
    private apiService: ApiService,
    private dataService: DataService,
    private navCtrl: NavController
  ) {}

  ngOnInit() {
    if (this.route.snapshot.data['special']) {
      this.category = this.route.snapshot.data['special'];
    }
    this.getCategory();
  }

  async getCategory() {
    //Get category from apiService
    const aux =
      (await this.apiService.getData('categories?category_id=' + this.route.snapshot.paramMap.get('id'))).data || null;
    if (aux && JSON.stringify(aux) != JSON.stringify(this.category)) this.category = aux;
  }

  goCategory(category) {
    console.log('goCategory: ', category.id);
    this.dataService.setData(category.id, category);
    this.navCtrl.navigateForward('/tecservice/home/category/' + category.id);
  }

  goBusinesses(category) {
    console.log('goBusinesses: ', category.id);
    this.dataService.setData(category.id, category);
    this.navCtrl.navigateForward('/tecservice/home/businesses/' + category.id);
  }
}
